import React, { useEffect, useState } from 'react';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import {
  Breadcrumb,
  Container,
  Divider,
  Menu,
  Segment
} from 'semantic-ui-react';

import Install from '../docs/Install';
import ModMenu from '../docs/ModMenu';

import Commands from '../docs/Commands';
import Custom from '../docs/Custom';
import Donations from '../docs/Donations';
import ChannelPoints from '../docs/ChannelPoints';
import { useAuth } from '../providers';

export default function KnowledgeBase() {
  let match = useRouteMatch();

  const dashboard = match.path === '/dashboard/support';
  const { user } = useAuth();

  const [activeItem, setActiveItem] = useState('install');

  useEffect(() => {
    let path = window.location.pathname.replace(match.path, '');
    path = path.startsWith('/') ? path.slice(1, path.length) : path;
    setActiveItem(path || 'install')
  }, [match]);

  return (
    <Segment inverted>
      <Container text className='description'>
        {dashboard ?
          <React.Fragment>
            <Breadcrumb size='huge'>
              <Breadcrumb.Section link as={Link} to='/dashboard'>Dashboard</Breadcrumb.Section>
              <Breadcrumb.Divider icon='right chevron' />
              <Breadcrumb.Section active>Knowledge Base</Breadcrumb.Section>
            </Breadcrumb>
            <Divider hidden />
          </React.Fragment>
          : ''}
        <div style={{ display: 'flex' }}>
          <Menu text vertical className='kbMenu'>
            <Menu.Item header>Getting Started</Menu.Item>
            <Menu.Item
              name='Install'
              active={activeItem === 'install'}
              as={Link}
              to={`${match.path}/install`}
            />
            <Menu.Item
              name='Mod Menu'
              active={activeItem === 'mod-menu'}
              as={Link}
              to={`${match.path}/mod-menu`}
            />
            <Menu.Item header>Advanced Settings</Menu.Item>
            <Menu.Item
              name='commands'
              active={activeItem === 'commands'}
              as={Link}
              to={`${match.path}/commands`}
            />
            <Menu.Item
              name='custom commands'
              active={activeItem === 'custom'}
              as={Link}
              to={`${match.path}/custom`}
            />
            <Menu.Item
              name='donations'
              active={activeItem === 'donations'}
              as={Link}
              to={`${match.path}/donations`}
            />
            <Menu.Item
              name='channel points'
              active={activeItem === 'channelpoints'}
              as={Link}
              to={`${match.path}/channelpoints`}
            />
            {user.admin ?
              <React.Fragment>
                <Menu.Item header>API</Menu.Item>
                <Menu.Item
                  name='overview'
                  active={activeItem === 'overview'}
                  as={Link}
                  to={`${match.path}/api/overview`}
                />
                <Menu.Item
                  name='get started'
                  active={activeItem === 'get started'}
                  as={Link}
                  to={`${match.path}/api/overview`}
                />
                <Menu.Item
                  name='reference'
                  active={activeItem === 'reference'}
                  as={Link}
                  to={`${match.path}/api/reference`}
                />
                <Menu.Item
                  name='integrations'
                  active={activeItem === 'integrations'}
                  as={Link}
                  to={`${match.path}/integrations`}
                />
              </React.Fragment>
              : ''}

            <Menu.Item header>Need more help?</Menu.Item>
            <Menu.Item
              name='Join the Discord!'
              as='a'
              href='https://discord.com/invite/5R9CSxzcep'
              target='_blank'
            />
          </Menu>
          {/*          
          <Accordion inverted as={Menu} vertical exclusive={false} defaultActiveIndex={[0, 1]}>
            <Accordion.Title
              active={true} //{isActive(0, 'install', 'mod-menu')}
              index={0}
              onClick={handleClick}
            >
              <Icon name='dropdown' />
              Getting Started
            </Accordion.Title>
            <Accordion.Content active={isActive(0, 'install', 'mod-menu')}>
              <Menu.Item
                name='Install'
                active={activeItem === 'install'}
                as={Link}
                to={`${match.path}/install`}
              />
              <Menu.Item
                name='Mod Menu'
                active={activeItem === 'mod-menu'}
                as={Link}
                to={`${match.path}/mod-menu`}
              />
            </Accordion.Content>

            <Accordion.Title
              active={true} //{isActive(1, 'commands', 'custom', 'donations', 'channelpoints')}
              index={1}
              onClick={handleClick}
            >
              <Icon name='dropdown' />
              Advanced Settings
            </Accordion.Title>
            <Accordion.Content active={isActive(1, 'commands', 'custom', 'donations', 'channelpoints')}>
              <Menu.Item
                name='commands'
                active={activeItem === 'commands'}
                as={Link}
                to={`${match.path}/commands`}
              />
              <Menu.Item
                name='custom commands'
                active={activeItem === 'custom'}
                as={Link}
                to={`${match.path}/custom`}
              />
              <Menu.Item
                name='donations'
                active={activeItem === 'donations'}
                as={Link}
                to={`${match.path}/donations`}
              />
              <Menu.Item
                name='channel points'
                active={activeItem === 'channelpoints'}
                as={Link}
                to={`${match.path}/channelpoints`}
              />
            </Accordion.Content>
            <Accordion.Title
              as='a'
              href='https://discord.com/invite/5R9CSxzcep'
              target='_blank'
            >
              Discord Server
            </Accordion.Title>
          </Accordion>
*/}
          <Container style={{ flex: 1, paddingLeft: '20px', borderLeft: '1px solid #555' }}>
            <Switch>
              <Route exact path={[`${match.path}/install`, match.path]}><Install user={user} /></Route>
              <Route exact path={`${match.path}/mod-menu`} component={ModMenu} />

              <Route exact path={`${match.path}/commands`} component={Commands} />
              <Route exact path={`${match.path}/custom`}><Custom user={user} /></Route>
              <Route exact path={`${match.path}/donations`}><Donations user={user} /></Route>
              <Route exact path={`${match.path}/channelpoints`} component={ChannelPoints} />
            </Switch>
          </Container>
        </div>
      </Container>
    </Segment>
  )
};
